import qs from 'qs';

import axiosInstance from '../protected';

import {getFiltersUrl} from '../api.config';

import {FilterQueryType, IFiltersSetPostBody, IFiltersSetDto} from './../../shared/types/filtersSet.types';
import {IPageable} from '../../shared/types/pageable.types';

export const FilterService = {
  async getAll(
    userId: number,
    filterType: FilterQueryType,
    name: string = '',
    attr: {
      pageable?: IPageable;
    } = {},
  ) {
    const res = await axiosInstance.get<{content: IFiltersSetDto[]}>(getFiltersUrl(), {
      params: {
        ...attr.pageable,
        name,
        userId,
        filterType,
      },
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, {arrayFormat: 'repeat'});
        },
      },
    });

    return res;
  },

  async get(id: string) {
    const res = await axiosInstance.post<IFiltersSetDto>(getFiltersUrl(`/findByIDs`), [id]);

    return res;
  },

  async create(filterSet: IFiltersSetPostBody) {
    const res = await axiosInstance.post<any>(getFiltersUrl(), filterSet);

    return res;
  },

  async update(filterSet: IFiltersSetDto) {
    const res = await axiosInstance.put<any>(getFiltersUrl(), filterSet);

    return res;
  },

  async delete(id: number) {
    await axiosInstance.delete(getFiltersUrl(`/`), {
      data: [id],
    });
  },

  async deleteAFew(IDs: number[]) {
    const deleted = await axiosInstance.delete<string[]>(getFiltersUrl(), {
      params: {
        id: IDs,
      },
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, {arrayFormat: 'repeat'});
        },
      },
    });

    return deleted;
  },
};
